import React from "react";

import { css, cx } from "@emotion/css";
import { Editor } from "@tiptap/core";

import { FontSizes } from "@/assets/fonts.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme, useTheme } from "@/theme/CreateTheme.ts";
import { RichTextFormattingButtons } from "@/uiKit/molecules/RichText/RichTextFormattingButtons.tsx";

export type TextEditorBubbleMenuProps = {
  id: string;
  editor: Editor;
  className?: string;
};

export const RichTextBubbleMenu: React.FC<TextEditorBubbleMenuProps> = ({ id, editor, className }) => {
  const styles = useStyles(makeStyles);
  const theme = useTheme();
  return (
    <div className={cx(styles.container, className)} id={id}>
      <RichTextFormattingButtons
        menuIdPrefix={id}
        toggled={{
          bold: editor.isActive("bold"),
          italic: editor.isActive("italic"),
          underlined: editor.isActive("underline"),
        }}
        onToggle={value => {
          switch (value) {
            case "bold":
              editor.chain().focus().toggleBold().run();
              break;
            case "italic":
              editor.chain().focus().toggleItalic().run();
              break;
            case "underlined":
              editor.chain().focus().toggleUnderline().run();
              break;
          }
        }}
        color={editor.getAttributes("textStyle")["color"] ?? theme.palette.common.black}
        onSelectColor={color => editor.chain().focus().setColor(color).run()}
      />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    backgroundColor: theme.palette.background.paper,
    display: "flex",
  }),
  icon: css({
    width: FontSizes.bodyLarge,
    height: FontSizes.bodyLarge,
  }),
});
